import React from "react";
import cn from "classnames";
import { useNavigate } from "react-router-dom";
import styles from "./Payment.module.sass";
import Item from "../Item";
import Icon from "../../../components/Icon";

const Confirmation = ({ className }) => {
  const navigate = useNavigate();

  const handleNewFormation = () => {
    // Rediriger vers une nouvelle création de formation
    navigate("/company/dashboard");
  };

  return (
    <Item
      className={cn(styles.card, className)}
      title="Confirmation"
      classTitle="title-green"
    >
      <div className={styles.content}>
        <div className={styles.successMessage}>
          <Icon name="check-circle" size="48" />
          <h3>Félicitations !</h3>
          <p>Vous avez validé la première étape du dossier.</p>
          <p>Vous pouvez maintenant ajouter les maître(s) d'apprentissage.</p>
        </div>
        
        <div className={styles.actions}>
          <button 
            className={cn("button", styles.primaryButton)}
            onClick={handleNewFormation}
          >
            Retourner à la page d'accueil
          </button>
        </div>
      </div>
    </Item>
  );
};

export default Confirmation;
